import React from 'react'
import { Box, Tabs, Tab, useTheme } from '@mui/material'
import { getSVG } from '../../utils/getSvg'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { getTranslation, getField, resolveShellHref } from '../../utils/utils'
import { getTabRows, uniqueByRoute } from './tabGroups'

const getValue = (data) => {
  if (data?.route)
    return data.route.split('/')[data.route.split('/').length - 1]
  else return data.key
}
const getValue2 = (data, isParent) => {
  return data.split('/')[isParent ? data.split('/').length - 2 : data.split('/').length - 1]
}

const capitalizeFirst = (s) => {
  if (!s) return s;
  
  // Common scripts where capitalization after spaces shouldn't be applied
  const nonLatinScripts = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u4E00-\u9FFF\u3400-\u4DBF\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\uAC00-\uD7AF]/;
  
  // Check if string contains characters from scripts where capitalization isn't appropriate
  if (nonLatinScripts.test(s)) {
    return s; // Return original string for Arabic, Chinese, Japanese, Korean, etc.
  }
  
  // Capitalize first letter and letters after spaces for Latin-based scripts
  return s.replace(/(^|\s)\S/g, (match) => match.toUpperCase());
};

const TopNavigation = ({
  language,
  permission,
  reformat,
  isParent,
  extraComponent,
  translation,
  sx
}) => {
  const pagesDictionary = getTranslation('page-names', translation)
  const access = uniqueByRoute(reformat(permission.subPage).filter((data) => data.type === 'hor' && data.route).sort((a, b) => a.order - b.order))
  const path = window.location.pathname
  const history = useHistory()
  const theme = useTheme()

  const handleChange = (event, newValue) => {
    history.push(`${permission.route}/${newValue}`)
  };
  const tabsSx = { ...sx, minHeight: 'unset', minWidth: 'unset', padding: '0 8px', maxWidth: '100vw' } // Adjust the padding as needed

  // `page` is a tab, or a tab group opening on its first tab.
  const renderTab = (page, i, { value = getValue(page), target = page, selected = getValue2(path) === getValue(page) } = {}) => (
    <Tab
      key={i}
      label={capitalizeFirst(getField(pagesDictionary, page.key, language))}
      value={value}
      href={resolveShellHref(`${permission.route}/${getValue(target)}`)}
      onClick={(event) => {
        event.preventDefault();
        handleChange(event, getValue(target));
      }}
      sx={{
          color: theme.palette.topNavSvg,
          minWidth: 'unset',
          minHeight: 'unset',
          padding: '14px',
          fontSize: '16px',
          textTransform: 'none',
          fontWeight: '400',
          '&.Mui-selected': { fontWeight: '400' }
      }}
      icon={getSVG(
        page.svgKey,
        selected ? theme.palette.primary.main : theme.palette.topNavSvg,
        { width: 20, height: 20 } // Adjust the icon size as needed
      )}
      iconPosition='start'
    />
  )

  const { top, groups } = getTabRows(permission.subPage, reformat)
  if (groups.length === 0)
    return (
      <Tabs
        value={getValue2(path, isParent)}
        onChange={handleChange}
        variant="scrollable"
        sx={tabsSx}
      >
        {access.map((acc, i) => renderTab(acc, i))}
      </Tabs>
    )

  // Grouped tabs (Stock Print Settings › Purchasing): the groups sit in the tab row, and the open
  // group's tabs in a second row. Each tab navigates on click, so the rows have no onChange.
  const current = getValue2(path, isParent)
  const openGroup = groups.find(({ tabs }) => tabs.some((tab) => getValue(tab) === current))
  const groupValue = (group) => `group:${group.key}`
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', maxWidth: '100vw' }}>
      <Tabs value={openGroup ? groupValue(openGroup.group) : current} variant="scrollable" sx={tabsSx}>
        {top.map((entry, i) => entry.tab
          ? renderTab(entry.tab, i)
          : renderTab(entry.group, i, { value: groupValue(entry.group), target: entry.tabs[0], selected: entry === openGroup })
        )}
      </Tabs>
      {openGroup && (
        <Tabs value={current} variant="scrollable" sx={tabsSx}>
          {openGroup.tabs.map((tab, i) => renderTab(tab, i))}
        </Tabs>
      )}
    </Box>
  )
}
const mapStateToProps = (state) => ({
  language: state.translation.language,
  translation: state.translation.translation
})
const mapDispatchToProps = (dispatch) => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(TopNavigation)